import { message } from 'antd'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { CartReturnType, CouponResult } from '@api/home/shopCart/types'
import { useSearch } from '@hooks'
import { loTrack } from '@utils'
import { Knife, Type } from '@utils/tool'

import { changeCoupon, changeCouponParamsType } from './action'
import useDrawerCouponTips from './useDrawerCouponTips'

export type Props = {
  data?: CartReturnType['coupons']
  shopListTotalInfo?: Omit<CartReturnType, 'blockList'>
  //data: CartReturnType['availableCoupons']
  // currentCode: string
  onChange?: (result: CouponResult) => any
  // couponList?: any
  readonly?: boolean // 详情页只读（也算详情页标识）
  selectCoupon?: any
  finishGrantCoupons?: any[] // 失效优惠券
  showSubscribe?
  couponInfo?
}

/**
 * coupon
 */
export const useCoupon = function (options: Props = {}) {
  const {
    data: Data,
    finishGrantCoupons,
    selectCoupon,
    // couponList,
    shopListTotalInfo,
    readonly,
    onChange
  } = options

  const data =
    shopListTotalInfo?.coupons?.length >= 1
      ? shopListTotalInfo.coupons
      : shopListTotalInfo?.availableCoupons || Data

  const [currentCoupon] = Knife.map(shopListTotalInfo?.addCouponList)

  const isUsedCoupon = !Type.isNever(currentCoupon)

  const currentCode = currentCoupon?.coupon

  const [zero] = data || []

  const [open, setOpen] = React.useState(false)

  const [value, useInputValue] = React.useState(currentCode)

  React.useEffect(() => {
    useInputValue(currentCode)
  }, [open])

  const { mutation, isLoading } = useSearch(
    ({ couponCode, clearCoupon, priority_coupon }) =>
      changeCoupon({ couponCode, clearCoupon, priority_coupon }),
    ['mutation']
  )

  const usingCoupon = (couponCode: string, priority_coupon?: '1') => {
    // currentCode 如果currentCode不变弹出警告提示
    const isCancel = currentCode === couponCode ? '1' : ''
    const params: changeCouponParamsType = { couponCode, clearCoupon: isCancel }
    priority_coupon === '1' && (params.priority_coupon = '1')
    mutation(params).then((result) => {
      const { code = 200, data = {}, message: msg = '' } = result
      if (code === 200) {
        message.success(
          isCancel ? 'Cancel successfully!' : 'Apply successfully!'
        )
        onChange?.(data as CouponResult)
        setOpen(false)
      }

      // code: 308 为满减/满件等优惠和 coupon 冲突
      if (code === 308) {
        openDrawerCouponTips?.(data?.message, couponCode)
      }
    })
  }

  const onApply = () => {
    if (Type.isVoid(value)) {
      message.error(`Please Enter The Coupon Code`)
      return
    }
    usingCoupon(value)
    loTrack('Coupon Drawer_Apply')
  }
  const removeCoupon = () => {
    usingCoupon(value)
    loTrack('Coupon_Remove')
  }
  const isLastValue = currentCode === value

  const onInputChange = (e) => {
    useInputValue(e.target.value)
  }
  const isLogin = useSelector((state: any) => state.app.isLogin, shallowEqual)

  const couponInfo = useSelector((state: any) => state.app.couponInfo)

  const { openDrawerCouponTips, CouponTips } = useDrawerCouponTips(usingCoupon)
  // console.log('data', data)
  return {
    couponInfo,
    removeCoupon,
    currentCoupon,
    isLogin,
    finishGrantCoupons,
    onInputChange,
    zero,
    onApply,
    isUsedCoupon,
    value,
    open,
    data,
    isLoading,
    selectCoupon,
    currentCode,
    readonly,
    onChange,
    useInputValue,
    usingCoupon,
    isLastValue,
    setOpen,
    CouponTips
  }
}

export default useCoupon
